import React from 'react';
import { FullPageMessage } from './FullPageMessage';

export const NotFound = () => {
  return <FullPageMessage message="404 - Not found" />;
};
